import { api } from '../boot/axios'

export default {
  list(params = {}) {
    return api.get('/tabs', { params }).then(r => r.data)
  },
  create(payload) {
    return api.post('/tabs', payload).then(r => r.data)
  },
  get(id) {
    return api.get(`/tabs/${id}`).then(r => r.data)
  },
  getRegisterLedger(id) {
    return api.get(`/tabs/${id}/register-ledger`).then(r => r.data)
  },
  getRegisterStatement(id) {
    return api.get(`/tabs/${id}/register-statement`).then(r => r.data)
  },
  registerCardOnFileOptions(id) {
    return api.get(`/tabs/${id}/register-card-on-file-options`).then(r => r.data)
  },
  registerCheckoutPreview (id, payload = {}) {
    return api.post(`/tabs/${id}/register-checkout-preview`, payload).then(r => r.data)
  },
  registerVoidEntry(tabId, entryId) {
    return api.post(`/tabs/${tabId}/entries/${entryId}/register-void`).then(r => r.data)
  },
  registerRestoreEntry(tabId, entryId) {
    return api.post(`/tabs/${tabId}/entries/${entryId}/register-restore`).then(r => r.data)
  },
  update(id, payload) {
    return api.patch(`/tabs/${id}`, payload).then(r => r.data)
  },
  addEntry(id, payload) {
    return api.post(`/tabs/${id}/entries`, payload).then(r => r.data)
  },
  voidEntry(tabId, entryId) {
    return api.post(`/tabs/${tabId}/entries/${entryId}/void`).then(r => r.data)
  },
  restoreEntry(tabId, entryId) {
    return api.post(`/tabs/${tabId}/entries/${entryId}/restore`).then(r => r.data)
  },
  addParticipant(id, payload) {
    return api.post(`/tabs/${id}/participants`, payload).then(r => r.data)
  },
  generatePaymentLink(id, payload = {}) {
    return api.post(`/tabs/${id}/payment-link`, payload).then(r => r.data)
  },
  emailPaymentLink(id, payload = {}) {
    return api.post(`/tabs/${id}/payment-link/email`, payload).then(r => r.data)
  },
  previewConvertToInvoice(id, params = {}) {
    return api.get(`/tabs/${id}/convert-to-invoice/preview`, { params }).then(r => r.data)
  },
  convertToInvoice(id, payload = {}) {
    return api.post(`/tabs/${id}/convert-to-invoice`, payload).then(r => r.data)
  },
  cardSetup(id, payload) {
    return api.post(`/tabs/${id}/card-setup`, payload).then(r => r.data)
  },
  recordManualPayment(id, payload) {
    return api.post(`/tabs/${id}/payments/manual`, payload).then(r => r.data)
  },
  recordRegisterPayment(id, payload) {
    return api.post(`/tabs/${id}/payments/register`, payload).then(r => r.data)
  },
  recordRegisterChargeFromSale(id, payload) {
    return api.post(`/tabs/${id}/charges/register-from-sale`, payload).then(r => r.data)
  },
  registerChargeFromCart(id, payload) {
    return api.post(`/tabs/${id}/charges/register-from-cart`, payload).then(r => r.data)
  },
  recordRegisterCredit(id, payload) {
    return api.post(`/tabs/${id}/credits/register`, payload).then(r => r.data)
  },
  close(id) {
    return api.post(`/tabs/${id}/close`).then(r => r.data)
  },
  cancel(id) {
    return api.post(`/tabs/${id}/cancel`).then(r => r.data)
  },
  payCardOnFile(id, payload) {
    return api.post(`/tabs/${id}/payments/card-on-file`, payload).then(r => r.data)
  },
  reportOpenTabs(params = {}) {
    return api.get('/reports/open-tabs', { params }).then(r => r.data)
  },
  exportOpenTabs(params = {}, format = 'csv') {
    const accept = format === 'xlsx'
      ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      : 'text/csv'
    return api.get('/reports/open-tabs', {
      params: { ...params, export: format },
      responseType: 'blob',
      headers: { Accept: accept }
    }).then(r => r.data)
  },
  getStatement(id) {
    return api.get(`/tabs/${id}/statement`).then(r => r.data)
  },
  downloadStatementPdf(id) {
    return api.get(`/tabs/${id}/statement/pdf`, { responseType: 'blob' }).then(r => r.data)
  },
  emailStatement(id, payload) {
    return api.post(`/tabs/${id}/statement/email`, payload).then(r => r.data)
  },
  smsStatement(id, payload) {
    return api.post(`/tabs/${id}/statement/sms`, payload).then(r => r.data)
  },
  exportStatement(id, format = 'csv') {
    const accept = format === 'xlsx'
      ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      : 'text/csv'
    return api.get(`/tabs/${id}/statement/export`, {
      params: { format },
      responseType: 'blob',
      headers: { Accept: accept }
    }).then(r => r.data)
  }
}
